import { useTranslation } from 'react-i18next';
import React from 'react';

import { Text } from 'libComponents';

import styles from './SocialTitle.module.css';

import CheckIcon from './img/check.svg';

function SocialTitle({ users }: { users?: string }) {
    const { t } = useTranslation();

    return (
        <>
            <Text
                text={t('onboardingFlow.obSocialProofConf.title', { users: users ?? '65' })}
                type="h6"
                color="surface-main"
                bold
            />
            <div className={styles.checkIcon}>
                <CheckIcon />
            </div>
            <Text
                text={t('users have chosen us')}
                type="small-text"
                color="surface-main"
                bold
                className={styles.lastTitleText}
            />
        </>
    );
}

export default SocialTitle;
